// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1rgip","colCheckbox":"styles_colCheckbox__3fRTA"};